import React, {useState} from "react";
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from "moment";
import {connect} from "react-redux";
import {Table} from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import getBroadbandPurchaseHistory from "../../../redux/action/broadBand/BroadBandPaymentHistory.action";
import LoadingBbBody from "../LoadingBbBody";
import ErrorAlert from "../../alerts/ErrorAlert";

const BroadBandPurhaseHistory = (props) => {
    var date = new Date();

    function addDays(theDate, days) {
        return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
    }

    var date1 = addDays(date, -1);

    const [startDate, setStartDate] = useState(moment(date1).format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment(date).format('YYYY-MM-DD'));
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState('');

    var date_diff_indays = function (date1, date2) {
        var dt1 = new Date(date1);
        var dt2 = new Date(date2);
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    }

    const searchButtonClick = () => {
        if (date_diff_indays(date, endDate) > 0) {
            setError('Sorry, Please select a Valid Date range for the Purchase History')
            setIsError(true)
        } else {
            if (date_diff_indays(date, endDate) > -90) {
                props.getBroadbandPurchaseHistory(props.serviceList.listofBBService[0].serviceID, startDate, endDate)
            } else {
                setError('Sorry, Unable to access Purchase History older than 3 calender months')
                setIsError(true)
            }
        }


    }


    const handleEvent = (event, picker) => {

        const stdate = picker.startDate.format("YYYY-MM-DD");
        const endate = picker.endDate.format("YYYY-MM-DD");
        setStartDate(stdate)
        setEndDate(endate)


    }


    return (
        <div className="broadBandPurhaseHistory">
            {isError ? <ErrorAlert setIsError={setIsError} setError={setError} error={error}/> : null}
            <div className='body-container'>
                <div className='title'>
                    Purchase History
                </div>


                <div className='wrapper'>

                    <div className='d-flex align-items-center'>

                        <div className="searchBar">
                            <DateRangePicker
                                locale={{format: "YYYY-MM-DD"}}
                                onApply={handleEvent}


                                initialSettings={{
                                    statDate: date1,
                                    endDate: date,
                                    maxDate: moment().startOf('hour').add(3, 'hour').toDate(),
                                    minDate: moment().subtract(90, 'days').toDate()

                                }}
                            >
                                <input type="text" className="form-control font-weight-bold"
                                       max={moment().format("YYYY-MM-DD")}/>
                            </DateRangePicker>

                        </div>

                        <div>
                            {/* <button className='text-center pHButton' onClick={searchButtonClick}>
                        Search
                    </button> */}
                            {/* <button className='text-center pHButton' onClick={() => props.getBroadbandPurchaseHistory(props.serviceList.listofBBService[0].serviceID, startDate, endDate)}> */}
                            <button className='text-center medium blue' onClick={searchButtonClick}>
                                Search
                            </button>
                        </div>
                    </div>

                    <div>
                        {
                            props.loading ? (
                                <LoadingBbBody loading={props.loading}/>
                            ) : (
                                <Table className='pHTable'>
                                    <thead className='pHTHeader'>
                                    <tr>
                                        <th>Purchased Data and Time</th>
                                        <th>Valid till Date</th>
                                        <th>Data Type</th>
                                        <th>Total amount</th>
                                        <th>Payment Mode</th>
                                        <th>Purchased Data Amount</th>
                                        <th>Data Received</th>
                                        <th>Activated by</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        props.error ? (
                                            <tr>
                                                <td colSpan="8">
                                                    <div className='PHTDErr'>

                                                        <div className='pHTError'>
                                                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M20.3438 29.5312C21.2499 29.5312 21.9844 30.2657 21.9844 31.1719C21.9844 32.0781 21.2499 32.8125 20.3438 32.8125H18.0469C17.1407 32.8125 16.4062 32.0781 16.4062 31.1719C16.4062 30.2657 17.1407 29.5312 18.0469 29.5312H20.3438ZM33.7969 20.7539C33.7969 19.8477 33.0624 19.1133 32.1562 19.1133H18.0469C17.1407 19.1133 16.4062 19.8477 16.4062 20.7539C16.4062 21.6601 17.1407 22.3945 18.0469 22.3945H32.1562C33.0624 22.3945 33.7969 21.6601 33.7969 20.7539ZM18.0469 12.5508H32.1562C33.0624 12.5508 33.7969 11.8163 33.7969 10.9102C33.7969 10.004 33.0624 9.26953 32.1562 9.26953H18.0469C17.1407 9.26953 16.4062 10.004 16.4062 10.9102C16.4062 11.8163 17.1407 12.5508 18.0469 12.5508ZM11.4844 29.5312H9.84375C8.93756 29.5312 8.20312 30.2657 8.20312 31.1719C8.20312 32.0781 8.93756 32.8125 9.84375 32.8125H11.4844C12.3906 32.8125 13.125 32.0781 13.125 31.1719C13.125 30.2657 12.3906 29.5312 11.4844 29.5312ZM11.4844 19.1133H9.84375C8.93756 19.1133 8.20312 19.8477 8.20312 20.7539C8.20312 21.6601 8.93756 22.3945 9.84375 22.3945H11.4844C12.3906 22.3945 13.125 21.6601 13.125 20.7539C13.125 19.8477 12.3906 19.1133 11.4844 19.1133ZM11.4844 9.26953H9.84375C8.93756 9.26953 8.20312 10.004 8.20312 10.9102C8.20312 11.8163 8.93756 12.5508 9.84375 12.5508H11.4844C12.3906 12.5508 13.125 11.8163 13.125 10.9102C13.125 10.004 12.3906 9.26953 11.4844 9.26953ZM41.5197 39.1991C42.1602 39.84 42.1602 40.8788 41.5197 41.5193C41.1992 41.8398 40.7791 42 40.3594 42C39.9396 42 39.5195 41.8398 39.1991 41.5197L36.4238 38.7444C35.3186 39.4048 34.0273 39.7852 32.6484 39.7852C28.5776 39.7852 25.2656 36.4731 25.2656 32.4023C25.2656 28.3315 28.5776 25.0195 32.6484 25.0195C36.7192 25.0195 40.0312 28.3315 40.0312 32.4023C40.0312 33.9087 39.5775 35.3106 38.7998 36.4799L41.5197 39.1991ZM32.6484 36.5039C34.9101 36.5039 36.75 34.664 36.75 32.4023C36.75 30.1407 34.9101 28.3008 32.6484 28.3008C30.3868 28.3008 28.5469 30.1407 28.5469 32.4023C28.5469 34.664 30.3868 36.5039 32.6484 36.5039ZM35.4375 0H6.5625C2.94383 0 0 2.94383 0 6.5625V35.4375C0 39.0562 2.94383 42 6.5625 42H23.4609C24.3671 42 25.1016 41.2656 25.1016 40.3594C25.1016 39.4532 24.3671 38.7188 23.4609 38.7188H6.5625C4.75333 38.7188 3.28125 37.2467 3.28125 35.4375V6.5625C3.28125 4.75333 4.75333 3.28125 6.5625 3.28125H35.4375C37.2467 3.28125 38.7188 4.75333 38.7188 6.5625V22.8047C38.7188 23.7109 39.4532 24.4453 40.3594 24.4453C41.2656 24.4453 42 23.7109 42 22.8047V6.5625C42 2.94383 39.0562 0 35.4375 0Z"
                                                                    fill="#B1ABAB"/>
                                                            </svg>

                                                            <h6>{props.error}</h6>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>

                                        ) : (
                                            props.array.length === 0 ? (
                                                <tr>
                                                    <td colSpan="8">
                                                        <div className='PHTDErr'>

                                                            <div className='pHTError'>
                                                                <svg width="42" height="42" viewBox="0 0 42 42"
                                                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M20.3438 29.5312C21.2499 29.5312 21.9844 30.2657 21.9844 31.1719C21.9844 32.0781 21.2499 32.8125 20.3438 32.8125H18.0469C17.1407 32.8125 16.4062 32.0781 16.4062 31.1719C16.4062 30.2657 17.1407 29.5312 18.0469 29.5312H20.3438ZM33.7969 20.7539C33.7969 19.8477 33.0624 19.1133 32.1562 19.1133H18.0469C17.1407 19.1133 16.4062 19.8477 16.4062 20.7539C16.4062 21.6601 17.1407 22.3945 18.0469 22.3945H32.1562C33.0624 22.3945 33.7969 21.6601 33.7969 20.7539ZM18.0469 12.5508H32.1562C33.0624 12.5508 33.7969 11.8163 33.7969 10.9102C33.7969 10.004 33.0624 9.26953 32.1562 9.26953H18.0469C17.1407 9.26953 16.4062 10.004 16.4062 10.9102C16.4062 11.8163 17.1407 12.5508 18.0469 12.5508ZM11.4844 29.5312H9.84375C8.93756 29.5312 8.20312 30.2657 8.20312 31.1719C8.20312 32.0781 8.93756 32.8125 9.84375 32.8125H11.4844C12.3906 32.8125 13.125 32.0781 13.125 31.1719C13.125 30.2657 12.3906 29.5312 11.4844 29.5312ZM11.4844 19.1133H9.84375C8.93756 19.1133 8.20312 19.8477 8.20312 20.7539C8.20312 21.6601 8.93756 22.3945 9.84375 22.3945H11.4844C12.3906 22.3945 13.125 21.6601 13.125 20.7539C13.125 19.8477 12.3906 19.1133 11.4844 19.1133ZM11.4844 9.26953H9.84375C8.93756 9.26953 8.20312 10.004 8.20312 10.9102C8.20312 11.8163 8.93756 12.5508 9.84375 12.5508H11.4844C12.3906 12.5508 13.125 11.8163 13.125 10.9102C13.125 10.004 12.3906 9.26953 11.4844 9.26953ZM41.5197 39.1991C42.1602 39.84 42.1602 40.8788 41.5197 41.5193C41.1992 41.8398 40.7791 42 40.3594 42C39.9396 42 39.5195 41.8398 39.1991 41.5197L36.4238 38.7444C35.3186 39.4048 34.0273 39.7852 32.6484 39.7852C28.5776 39.7852 25.2656 36.4731 25.2656 32.4023C25.2656 28.3315 28.5776 25.0195 32.6484 25.0195C36.7192 25.0195 40.0312 28.3315 40.0312 32.4023C40.0312 33.9087 39.5775 35.3106 38.7998 36.4799L41.5197 39.1991ZM32.6484 36.5039C34.9101 36.5039 36.75 34.664 36.75 32.4023C36.75 30.1407 34.9101 28.3008 32.6484 28.3008C30.3868 28.3008 28.5469 30.1407 28.5469 32.4023C28.5469 34.664 30.3868 36.5039 32.6484 36.5039ZM35.4375 0H6.5625C2.94383 0 0 2.94383 0 6.5625V35.4375C0 39.0562 2.94383 42 6.5625 42H23.4609C24.3671 42 25.1016 41.2656 25.1016 40.3594C25.1016 39.4532 24.3671 38.7188 23.4609 38.7188H6.5625C4.75333 38.7188 3.28125 37.2467 3.28125 35.4375V6.5625C3.28125 4.75333 4.75333 3.28125 6.5625 3.28125H35.4375C37.2467 3.28125 38.7188 4.75333 38.7188 6.5625V22.8047C38.7188 23.7109 39.4532 24.4453 40.3594 24.4453C41.2656 24.4453 42 23.7109 42 22.8047V6.5625C42 2.94383 39.0562 0 35.4375 0Z"
                                                                        fill="#B1ABAB"/>
                                                                </svg>

                                                                <h6>No Purchase records found</h6>
                                                            </div>

                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (

                                                props.array.map((val, index) => {
                                                    return <tr key={index}
                                                               className={index % 2 ? ("pHTBodyLight") : ("pHTBodyDark")}>
                                                        <td>{val.transactionTime}</td>
                                                        <td>{val.validTill}</td>
                                                        <td>{val.vasType}</td>
                                                        <td>{val.payPrice}</td>
                                                        <td>{val.payType}</td>
                                                        <td>{val.vasPackage}</td>
                                                        <td>{val.vasPackage}</td>
                                                        <td>{val.subscriberId}</td>
                                                    </tr>
                                                })

                                            )

                                        )

                                    }
                                    </tbody>
                                </Table>
                            )
                        }
                    </div>
                </div>
            </div>

        </div>
    )


}

const mapStateToProps = state => ({
    loading: state.broadBandPayment.loading,
    array: state.broadBandPayment.dataBundle,
    error: state.broadBandPayment.error,
    serviceList: state.accountDetails.service_list
})

export default connect(mapStateToProps, {getBroadbandPurchaseHistory})(BroadBandPurhaseHistory)
